module.exports = __webpack_public_path__ + "static/img/bg-9.2d1e3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb-activity/bg-9.png
// module id = eNrt
// module chunks = 39